import React from "react";
import Page from '../core/screens/Page';

import '../css/screens/TestPage.scss';
import KTween from '../core/KTween';

export default class TestPage extends Page
{

	tl:HTMLDivElement;
	tr:HTMLDivElement;
	bl:HTMLDivElement;
	br:HTMLDivElement;

	_leftIn = -1;
	_leftOpen = -1;
	_rightIn = -1;
	_rightOpen = -1;
	componentDidMount()
	{
		// window.addEventListener('mousedown', this._mouseDown);
	}

	_mouseDown = (e) =>
	{
		this.hide();
	}

	get leftIn(){
		return this._leftIn;
	}

	set leftIn(value){
		if(value == this._leftIn) return;
		this._leftIn = value;
		this.tl.style['transform'] = 'translateX(' + (1 - value) * 10 + 'vw)';
		this.bl.style['transform'] = 'translateX(' + (1 - value) * 10 + 'vw)';
		this.tl.style['width'] = value * 100 + '%';
		this.bl.style['width'] = value * 100 + '%';
	}

	get leftOpen(){
		return this._leftOpen;
	}

	set leftOpen(value){
		if(value == this._leftOpen) return;
		this._leftOpen = value;
		if(value < 1)
		{
			let h = value * 150;
			if(h < 0) h = 0;
			this.tl.style['bottom'] = 'calc(50% - 1px)';
			this.bl.style['top'] = '50%';
			this.tl.style['height'] = 'calc(' + h + '% + 1px)';
			this.bl.style['height'] = 'calc(' + h + '% + 1px)';
		}else if(value >= 1)
		{
			let h = (value - 1);
			if(h > 1) h = 1;
			this.tl.style['bottom'] = (50 + h * 75) + '%';
			this.bl.style['top'] = (h * 100 + 50) + '%';
		}
	}

	get rightIn(){
		return this._rightIn;
	}

	set rightIn(value){
		if(value == this._rightIn) return;
		this._rightIn = value;
		this.tr.style['transform'] = 'translateX(-' + (1 - value) * 10 + 'vw)';
		this.br.style['transform'] = 'translateX(-' + (1 - value) * 10 + 'vw)';
		this.tr.style['width'] = value * 100 + '%';
		this.br.style['width'] = value * 100 + '%';
	}

	get rightOpen(){
		return this._rightOpen;
	}

	set rightOpen(value){
		if(value == this._rightOpen) return;
		this._rightOpen = value;
		if(value < 1)
		{
			let h = value * 150;
			if(h < 0) h = 0;
			this.tr.style['bottom'] = 'calc(50% - 1px)';
			this.br.style['top'] = '50%';
			this.tr.style['height'] = 'calc(' + h + '% + 1px)';
			this.br.style['height'] = 'calc(' + h + '% + 1px)';
		}else if(value >= 1)
		{
			let h = (value - 1);
			if(h < 0) h = 0;
			this.tr.style['bottom'] = 'calc(' + (50 + h * 75) + '% - 1px)';
			this.br.style['top'] = (h * 100 + 50) + '%';
		}
	}

	hide()
	{
		this.leftIn = 0;
		this.rightIn = 0;
		this.leftOpen = 0;
		this.rightOpen = 0;
		KTween.tween(this, {leftIn: 1}, 'easeOutQuart', 0.4);
		KTween.tween(this, {rightIn: 1}, 'easeOutQuart', 0.4, 0.1);
		KTween.tween(this, {leftOpen: 1, rightOpen: 1}, 'easeInCirc', 0.4, 0.5);
		KTween.tween(this, {leftOpen: 2, rightOpen: 2}, 'easeOutQuad', 0.4, 0.9);
	}



	render()
	{
		return this.wrap(
			<div className="transition">
				{/* <div className="skew-left">
					<div ref={r => this.tl = r} className="plane tl"></div>
					<div ref={r => this.bl = r} className="plane bl"></div>
				</div>
				<div className="skew-right">
					<div ref={r => this.tr = r} className="plane tr"></div>
					<div ref={r => this.br = r} className="plane br"></div>
				</div> */}
			</div>
		);
	}
}